import { render, staticRenderFns } from "./LineChartPue.vue?vue&type=template&id=06147f8d&scoped=true&"
import script from "./LineChartPue.vue?vue&type=script&lang=js&"
export * from "./LineChartPue.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "06147f8d",
  null
  
)

export default component.exports